import { Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { ModalSize, ModalType } from './modal.types';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'core-ui-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  // templates
  @ContentChild('content') content: TemplateRef<any>;
  @ContentChild('footer') footer: TemplateRef<any>;

  // settings for style and behavior
  @Input() public visible = false;
  @Input() public type: ModalType;
  @Input() public size: ModalSize = ModalSize.Medium;
  @Output() visibleChange = new EventEmitter<boolean>();

  // settings for content
  @Input() public title: string;
  @Input() public message: string;
  @Input() public icon: string;

  // settings for default buttons
  @Input() public acceptLabel = this.transloco.translate('common.labels.ok');
  @Input() public acceptIcon: string | null = null;
  @Input() public acceptVisible = true;
  @Output() public accept = new EventEmitter<void>();
  @Input() public rejectLabel = this.transloco.translate('common.labels.cancel');
  @Input() public rejectIcon: string | null = null;
  @Input() public rejectVisible = false;
  @Output() public reject = new EventEmitter<void>();

  // settings for p-dialog
  @Input() public modal = true;
  @Input() public closable = true;
  @Input() public draggable = false;
  @Input() public resizable = false;

  constructor(
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
  }

  public onClose(visible: boolean): void {
    this.visible = visible;
    this.visibleChange.emit(this.visible);
  }

  public onAcceptClicked(): void {
    this.accept.emit();
  }

  public onRejectClicked(): void {
    this.reject.emit();
  }

}
